module.exports = {
      id: "1938e49f09febb601dcf46132065a15cequipment-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#1938e49f09febb601dcf46132065a15cequipment-none.svg",
      toString: function () {
        return this.url;
      }
    }